<script lang="ts">
	import { capitalize } from '../utils/strings';
	import { attrValue } from '../utils/html';
	import InputCheckbox from './InputCheckbox.svelte';
	import type { InputChipsProps } from './inputs/types';
	import {
		getMdBgColorClassName,
		getTextColorClassName,
		getMdLightBgColorClassName,
		getMdBorderColorClassName,
		getMdTextColorClassName
	} from '$lib/theme/colors.js';
	import { viewport } from '$lib/stores';
	export let props: InputChipsProps;

	$: color = props.color;
	$: checked = props.checked || false;
	$: disabled = props.disabled || false;
	$: value = props.value || '';
	$: classNames = props.classNames || null;
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-to-interactive-role -->
<!-- svelte-ignore a11y-label-has-associated-control -->
<label
	class={attrValue([
		'chip',
		`${
			color
				? `md:text-white ${getTextColorClassName(color)} ${getMdBgColorClassName(color)}`
				: 'md:border md:border-grey-light items-center'
		}`,
		`${checked && !color ? 'md:!border-secondary' : ''}`,
		`${
			checked && color
				? `md:border ${getMdBorderColorClassName(color)} ${getMdLightBgColorClassName(
						color
					)} ${getMdTextColorClassName(color)}`
				: ''
		}`,

		classNames
	])}
	class:disabled
	class:checked
	role="button"
	on:click
>
	{#if $viewport.isMobile}
		<InputCheckbox
			{disabled}
			{value}
			label={capitalize(props.label)}
			bind:checked={props.checked}
			classNames="w-full md:w-auto"
			labelClassNames="w-full flex flex-row-reverse justify-between space-x-reverse md:hidden"
		/>
	{:else}
		<div class="label">
			<slot>{capitalize(props.label)}</slot>
		</div>
	{/if}
</label>

<style lang="postcss">
	.chip {
		@apply font-medium leading-none select-none transition inline-flex;
		@apply md:flex md:items-center md:px-4 md:py-3 md:text-center md:rounded-lg;
		&.checked {
			@apply font-semibold;
		}
	}
</style>
